import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PrivatePage, JobsTable } from "@/components";

/**
 * Displays project uploads.
 */
const __default__ = {
  name: "UploadStatusView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), {
    title: "Project Uploads",
    subtitle: "Select an upload below to see more details on its status."
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(JobsTable), { "display-project-jobs": false })
    ]),
    _: 1
  }))
}
}

})